import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {getNestedDataSources} from "../../../../redux/data/dataActions";
import SettingsForm from "../../components/settings/SettingsForm";
import {appSetModalContent} from "../../../../redux/app/appActions";
import { LinearProgress, styled, Card, CardHeader, CardContent } from "@mui/material";
import ListenerIcon from "../../../application/ListenerIcon";
import {ComponentWrapper} from "../wrappers/ComponentWrapper";
import {useTranslation} from "react-i18next";


const PREFIX = 'CardWrapper';

const classes = {
    linearProgress: `${PREFIX}-linearProgress`
};

const StyledComponentWrapper = styled(ComponentWrapper)((
    {
        theme
    }
) => ({
    [`& .${classes.linearProgress}`]: {
		height: '1px'
	}
}));

export function CardWrapper({xId, component, parseComponent, level, xGridDraggable}) {

	const dispatch = useDispatch();
	const { t, i18n } = useTranslation();

	// App State
	const pageID = useSelector(state => state.app.pageID);
	const editXId = useSelector(state => state.page.componentEdit.xId);
	const componentUpdated = useSelector(state => state.page.componentUpdated);

	// console.log('ParseCard->', container);
	const components = component.configuration.components;

	// Component State
	const [title, setTitle] = useState(component.configuration?.name?.title ? component.configuration?.name?.title : '');
	const [subtitle, setSubTitle] = useState(component.configuration?.name?.subtitle ? component.configuration?.name?.subtitle : '');
	const [componentsLoading, setComponentsLoading] = useState(0);
	const [childJSX, setChildJSX] = useState(null);
	const [dataSourceNames, setDataSourceNames] = useState([]);
	const [cardHeaderStyle, setCardHeaderStyle] = useState({});
	const [cardContentStyle, setCardContentStyle] = useState({});

	const avatar = null;
	const action = null;
	// TODO: Media

	useEffect(()=> {
		const dsNames = [];
		getNestedDataSources(dsNames, [component]);
		// console.log('pulled out of config', dsNames);

		const comp = <React.Fragment>
			{components.map((c,i) => {
				// if (c?.configuration?.dataSource?.name) {
				//     dsNames.push(c.configuration.dataSource.name.toLowerCase())
				// }
				return <div key={i}> {parseComponent(c, true, level, false, null, cardContentsLoading, cardContentsLoaded)} </div>
			})}</React.Fragment>
		setChildJSX(comp);
		setDataSourceNames(dsNames);

	}, []);

	useEffect(() => {
		resizeCard();
	},[title, subtitle]);

	// Titles
	useEffect(() => {
		if (xId) {
			if (componentUpdated.id === xId) {
				setTitle(componentUpdated.config.name?.title ? componentUpdated.config.name.title : '');
				setSubTitle(componentUpdated.config.name?.subtitle ? componentUpdated.config.name.subtitle : '');
			}
		}
	}, [componentUpdated]);

	// xEdit
	useEffect(() => {
		if (editXId) {
			if ((editXId === xId) && (pageID)) {

				const placeholders = {
					title: title,
					subtitle: subtitle
				}

				const settingsConfig = {
					title: 'Card Configuration',
					parent: {
						minWidth: '400px',
						maxWidth: '400px',
						minHeight: '520px',
						maxHeight: '520px'
					},
					paper: null,
					button: null,
					content: <SettingsForm pageID={pageID} xId={xId} configuration={component.configuration}
										   schemaType={'Card'} placeholders={placeholders}/>,
					tooltipContent: null
				}
				dispatch(appSetModalContent(settingsConfig));
			}
		}
	},[editXId, pageID]);

	// NOTE: This was producing call stack issues on the quantities page... need to revisit
	function cardContentsLoading() {
		// console.log('cardContentsLoading');
		setComponentsLoading(componentsLoading + 1);
	}

	function cardContentsLoaded() {
		// console.log('cardContentsLoaded');
		setComponentsLoading(componentsLoading - 1 <= 0 ? 0 : componentsLoading - 1);
	}

	const resizeCard = () => {

		const newCardHeaderStyle = Object.assign({}, {padding: '8px 8px 0px 8px'});
		const newCardContentStyle = Object.assign({}, {
			height: 'calc(100% - 49px)'
			,overflow: 'auto'
			,padding: '0px'}
		);

		if (title && subtitle) {
			// Default Style
		} else if (title) {
			// Title Only
			newCardHeaderStyle.height = '29px';
			newCardContentStyle.height = 'calc(100% - 29px)';
		} else if (subtitle) {
			// Subtitle Only
			newCardHeaderStyle.height = '29px';
			newCardContentStyle.height = 'calc(100% - 29px)';
		} else {
			// No title
			newCardHeaderStyle.height = '0px';
			newCardHeaderStyle.padding = '0px';
			newCardContentStyle.height = '100%';
		}
		setCardHeaderStyle(newCardHeaderStyle);
		setCardContentStyle(newCardContentStyle);
	}

	// console.log('card render');
	return <StyledComponentWrapper component={
                <React.Fragment>
                    {componentsLoading > 0 &&
                        <LinearProgress className={classes.linearProgress}/>
                    }
                    {componentsLoading === 0 &&
                        <div style={{height: '1px'}}></div>
                    }
                    <Card style={{height: 'calc(100% - 1px)', padding: '0px', boxShadow: 'none'}}>
                        <CardHeader
                            style={cardHeaderStyle}
                            avatar={avatar}
                            action={action}
                            titleTypographyProps={{color: 'textPrimary', variant: 'subtitle2'}}
                            title={t(title)}
                            subheader={t(subtitle)}
                            subheaderTypographyProps={{color: 'textSecondary', variant: 'body2'}}
                        />
                        <CardContent style={cardContentStyle}>
                            {childJSX}
                            <ListenerIcon invalid={false} dataSourceNames={dataSourceNames} />
                        </CardContent>
                    </Card>
                </React.Fragment>
                }
                xId={xGridDraggable ? component.id : null}
                paper={component?.wrapper?.paper}
                modal={component?.wrapper?.modal}
                tooltip={component?.wrapper?.tooltip}
                link={component?.wrapper?.link}
                type={component.type}
                xGridDraggable={xGridDraggable}
            >
            </StyledComponentWrapper>
}